// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609162200/js/" + chunkId + "." + {"44":"0e4f7c75","225":"d4d31a68","481":"7126172e","486":"83a28349","770":"762d596f"}[chunkId] + ".0.29895119730500797.chunk.js";
};